import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Form, { FormBody, FormActions, DateInput, SelectInput, TextInput } from "../../Form";
import FormMultiSelectInput from "../../FormMultiSelectInput";
import _ from 'lodash';
import ImageSlider from '../../ImageSlider';
import ImageGrid from '../../ImageGrid';
import { BASE_URL } from "../../../config";
import Spinner from '../../Spinner';
import Button from '../../Form/Button';

@inject('stationStore', 'imageTagStore', 'imageStore')
@observer
class Search extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired
  }

  grid_rows = [1, 2, 3, 4, 5]

  @observable multiStationOptions = [];
  @observable multiTagOptions = [];
  @observable filters = {
    date_created: observable({
      from: moment().subtract(10, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    }),
    date_modified: observable({
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    }),
    image_type: '',
    rating: '',
    direction: '',
  };
  @observable filters_select = {
    image_type: false,
    stations: true,
    tags: false,
    date_created: true,
    date_modified: true,
    rating: false,
    direction: false,
  };

  @observable images = [];
  @observable isLoading = false;

  componentWillMount() {
    const { imageTagStore, stationStore } = this.props;
    if (!imageTagStore.isLoading && !imageTagStore.items.length) imageTagStore.fetchItems();
    if (!stationStore.isLoading && !stationStore.items.length) stationStore.fetchItems();
    this.populateOptions();
  }

  populateOptions = () => {
    this.populateStationOptions();
    this.populateTagOptions();
  };

  populateStationOptions = () => {
    const { stationStore } = this.props;
    if (stationStore.isLoading) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      if (process.env.NODE_ENV !== 'production') {
        this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, tags: item.tags, value: [186].indexOf(item.id) > -1 }));
        this.filters.date_created.from = '2024-01-01';
        this.filters_select.date_modified = false;
      } else {
        this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false, tags: item.tags }));
      }
    }
  }

  populateTagOptions = () => {
    const { imageTagStore } = this.props;
    if (imageTagStore.isLoading) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      this.multiTagOptions = imageTagStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false }));
    }
  }

  @action handleChange = (field, e) => _.set(this.filters, field, e.target.value);
  @action onMultiOptionClicked = item => item.value = !item.value;

  optionsReducer = options => options.reduce((acc, item) => {
    if (item.value === true) acc.push(item.id);
    return acc;
  }, []);

  onView = e => {
    e.preventDefault();
    const { imageStore } = this.props;
    const { notify } = this.context;

    let payload = _.pick(Object.assign({}, toJS(this.filters), {
      stations: this.optionsReducer(this.multiStationOptions),
      tags: this.optionsReducer(this.multiTagOptions)
    }), Object.keys(this.filters_select).filter(filter_key => this.filters_select[filter_key]));

    this.images = [];
    this.isLoading = true;
    imageStore.searchImage(payload)
      .then(res => {
        this.images = res;
      })
      .catch(e => {
        console.error(e);
        notify.error({ message: e.toString() });
      })
      .finally(() => this.isLoading = false);
  }

  _dateInput = (value, onChange, readOnly) => (
    <input type={"date"} value={value} onChange={onChange} readOnly={readOnly} />
  );

  _renderWithSelect = (field, InputComponent) => (
    <div className='flex flex-row'>
      <input type='checkbox' style={{ margin: '20px 10px' }} checked={this.filters_select[field]} onChange={() => this.filters_select[field] = !this.filters_select[field]} />
      <InputComponent />
    </div>
  )

  render() {
    const { imageTagStore, stationStore } = this.props;
    const { date_created, date_modified, direction, image_type, rating } = this.filters;

    return (
      <div className='inline-grid-reverse'>
        <div className='flex-grow'>
          {/* {!!this.images.length && <ImageSlider images={this.images} baseUrl={`${BASE_URL}/idaq-files`} />} */}
          {this.isLoading ? <Spinner /> : !!this.images.length && <ImageGrid images={this.images} baseUrl={`${BASE_URL}/idaq-files`} />}
          {/* {!!this.images.length && this.images.slice(0,12).map(item =>  <img className='grid-item' src={`${BASE_URL}/idaq-files/${item.source}`}/>)} */}
        </div>
        <Form>
          <FormBody>
            <div className='flex flex-row'>
              <input type='checkbox' style={{ margin: '20px 10px' }} checked={this.filters_select.image_type} onChange={() => this.filters_select.image_type = !this.filters_select.image_type} />
              <TextInput label={"Image Type"} value={image_type} onChange={e => this.handleChange('image_type', e)} readOnly={!this.filters_select.image_type} />
            </div>

            <div className='flex flex-row'>
              <input type='checkbox' style={{ margin: '20px 10px' }} checked={this.filters_select.stations} onChange={() => this.filters_select.stations = !this.filters_select.stations} />
              <FormMultiSelectInput id='station-multi-select' label='Stations' options={this.multiStationOptions} optionClicked={this.onMultiOptionClicked} isLoading={stationStore.isLoading} filterOptions={stationStore.filterStations} />
            </div>

            <div className='flex flex-row'>
              <input type='checkbox' style={{ margin: '20px 10px' }} checked={this.filters_select.tags} onChange={() => this.filters_select.tags = !this.filters_select.tags} />
              <FormMultiSelectInput id='tag-multi-select' label='Tags' options={this.multiTagOptions} optionClicked={this.onMultiOptionClicked} isLoading={imageTagStore.isLoading} />
            </div>

            <div className='flex flex-row'>
              <input type='checkbox' style={{ margin: '20px 10px' }} checked={this.filters_select.date_created} onChange={() => this.filters_select.date_created = !this.filters_select.date_created} />
              <div className='formInput rangeInput'>
                <label>Date Created</label>
                {this._dateInput(date_created.from, e => this.handleChange('date_created.from', e), !this.filters_select.date_created)}
                <span style={{ padding: 10 }}>to</span>
                {this._dateInput(date_created.to, e => this.handleChange('date_created.to', e), !this.filters_select.date_created)}
              </div>
            </div>

            <div className='flex flex-row'>
              <input type='checkbox' style={{ margin: '20px 10px' }} checked={this.filters_select.date_modified} onChange={() => this.filters_select.date_modified = !this.filters_select.date_modified} />
              <div className='formInput rangeInput'>
                <label>Date Modified</label>
                {this._dateInput(date_modified.from, e => this.handleChange('date_modified.from', e), !this.filters_select.date_modified)}
                <span style={{ padding: 10 }}>to</span>
                {this._dateInput(date_modified.to, e => this.handleChange('date_modified.to', e), !this.filters_select.date_modified)}
              </div>
            </div>

            <div className='flex flex-row'>
              <input type='checkbox' style={{ margin: '20px 10px' }} checked={this.filters_select.rating} onChange={() => this.filters_select.rating = !this.filters_select.rating} />
              <TextInput label={"Rating"} value={rating} inputProps={{ name: 'rating' }} type={'number'} min={0} max={5} onChange={e => this.handleChange('rating', e)} readOnly={!this.filters_select.rating} />
            </div>

            <div className='flex flex-row'>
              <input type='checkbox' style={{ margin: '20px 10px' }} checked={this.filters_select.direction} onChange={() => this.filters_select.direction = !this.filters_select.direction} />
              <TextInput label={"Direction"} value={direction} inputProps={{ name: 'direction' }} type={'number'} onChange={e => this.handleChange('direction', e)} readOnly={!this.filters_select.direction} />
            </div>
          </FormBody>
          <FormActions>
            <Button label={'View'} onClick={this.onView} isLoading={this.isLoading} />
          </FormActions>
        </Form>
      </div >
    );
  }
}

export default Search;


// WEBPACK FOOTER //
// ./src/components/Images/pages/Search.js